export default __webpack_public_path__ + "static/media/au_tpco.3e9cb007.jpg";